

<template>
    <div class="mt-6">
        <v-carousel cycle height="900" hide-delimiter-background show-arrows-on-hover>
            <v-carousel-item v-for="(slide, i) in filterComunicadosByPerfil" :key="i" reverse-transition="fade-transition"
                transition="fade-transition">


                <v-row class="d-flex text-center" v-if="slide.estado_titulo" dense>
                    <v-col cols="12">
                        <h1>{{ slide.titulo }}</h1>
                    </v-col>
                    <v-col cols="12">
                        <h3>{{ slide.subtitulo }}</h3>
                    </v-col>
                </v-row>
                <v-row dense class="d-flex text-center subtitle">
                    <v-col cols="12" style="padding-left: 30px; padding-right: 30px;">
                        <div v-html="slide.contenido"></div>
                    </v-col>
                </v-row>

                <template v-if="checkExtension(slide.nombre_original)">
                    <video width="100%" height="80%" controls>
                        <source :src="`${baseUrlS3}${slide.uri}`" type="video/mp4">
                        Tu navegador no soporta videos.
                    </video>
                </template>

                <v-sheet v-else class="rounded-sheet" height="80%" :style="`background-image:url('${baseUrlS3}${slide.uri}');`">

                </v-sheet>

            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
    name: 'Comunicados',

    data: () => ({
        paramComponente: { id_modulo: 4, id_submodulo: 2 },
        loginSession: sessionStorage,
        baseUrl: API_URL,
        baseS3: BUCKET_ORIGIN_SPACE,
        slides: [],
        titulo: '',
        subtitulo: ''
    }),

    mounted() {
        this.loadMain()
    },

    created() {
        this.actualizarParamentro()
    },
    watch: {
        // queryRouter(e) {
        //     alert(e)
        // },
    },

    computed: {
        // a computed getter
        ...mapGetters('login', ['componenteEvento']),
        queryRouter() {
          
            return this.$route.params.name;
        },
        filterComunicadosByPerfil() {
            if (this.slides.length > 0) {
                return this.slides.filter(e => e.perfil.descripcion_perfil == this.loginSession.descripcion_perfil)
            }
            return []
        },

        baseUrlS3() {
            return this.baseS3 + '/'
        }
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
        // -- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////


        async loadMain() {
            this.getComunicados();
        },

        async getComunicados() {
            try {
                let fechaActual = moment().format("YYYY-MM-DD");
                let params = `?id_perfil=${sessionStorage.id_perfil}&id_ano_lectivo=${sessionStorage.id_ano_lectivo}&fecha=${fechaActual}&activo=${true}`;
                let alumno = await this.isAlumno();
                if (alumno) {
                    params += `&id_nivel=${alumno.id_nivel_seccion}&id_grado=${alumno.id_grado_seccion}&id_seccion=${alumno.id_seccion}`;
                } else {
                    let docente = await this.isDocente();
                    if (docente) {
                        params += `&id_nivel=${docente.id_adm_nivel}&id_grado=${docente.id_adm_grado}&id_seccion=${docente.id_seccion}`;
                    }
                }
                let response = await axios.get(
                    `/inicio/comunicados/${sessionStorage.id_colegio}${params}`
                );

                this.slides = response.data;
             
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        checkExtension(nombre) {
           
            if (!nombre) return false; // Retorna false si filename no está definido
            // expresión regular que busca las extensiones al final del nombre del archivo
            const regex = /\.(mp4|mov|avi|mkv)$/;
            // Retorna true si encuentra alguna de las extensiones, false en caso contrario
            let resp = regex.test(nombre);
          
            return resp
        },

        async isAlumno() {
            try {
                let response = await axios.post('/sistema/integral/getAlumnoPersona', {
                    idColegio: sessionStorage.id_colegio,
                    idPersona: sessionStorage.id_persona
                })

                if (response.data.messageT === 'S') {
                    return response.data.payload;
                } else {
                    return false
                }

            } catch (e) {
                return false;
            }
        },

        async isDocente() {
         
            try {
                const response = await axios.post('/sistema/integral/getDocentePersona', {
                    idColegio: sessionStorage.id_colegio,
                    idPersona: sessionStorage.id_persona
                }
                // ,{
                //     headers:{
                //         'Authorization': `Bearer ${sessionStorage.token}`
                //     }
                // }
                )

                if (response.data.messageT === 'S') {
                    return response.data.payload;
                } else {
                    return false
                }

            } catch (e) {
                return false;
            }
        },
    },
};
</script>

<style scoped>
.rounded-sheet {
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
}

.subtitle {
    overflow-wrap: break-word;

}
</style>
